"use strict";
import initSimpleSlider from '../../shared/simple-slider.common.js';
import activateSeeMoreButton from '../../shared/seeMoreButton.common.js';

const initNonVueComponents = () => {
	const resourcePage = document.querySelector('[am-resource-page]');
	const extraContent = resourcePage.querySelector('[data-extra-content]');
	const speakersSlider = resourcePage.querySelector('.speakers');
	
	if (extraContent) {
		const extraContentSelector = extraContent.querySelector('.text');

		activateSeeMoreButton(extraContentSelector);
	}
	
	if (speakersSlider) {
		initSimpleSlider(speakersSlider);
	}
};

export default initNonVueComponents;